$(document).ready(function () {
  //toggle show password
  $('.js-form-group__password-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('show');
    var dataAttribute = $(this).attr('data-password');
    var input = $('#' + dataAttribute);
    input.attr('type') === 'password' ? input.attr('type', 'text') : input.attr('type', 'password');
  });

  // Image Upload Form
  $('#CompanyLogo').change(function (e) {
    var fileName = e.target.files[0].name;
    $('.js-form-control--img-upload-2').attr('value', `${fileName}`);
  });

  // File Upload CV
  $('#CVUpload').change(function (e) {
    var fileName = e.target.files[0].name;
    var fileSize = e.target.files[0].size;
    var fileCheck = 'assets/media/images/sign-up-document-after.svg';
    $('.js-form-group-header-wrap').attr('src', `${fileCheck}`);
    $('.js-form-group--file-upload').addClass('preview');
    $('.js-form-group__prompt').addClass('preview');
    $('.js-text-header').text(`${fileName}`);
    $('.js-text-sub-header').text(`${fileSize} KB`);
  });

  // Select Company Sector
  let sectorSelect = $(document).find('.js-sector-select');
  if (sectorSelect.length) {
    sectorSelect.select2({
      placeholder: 'Select Sector',
      minimumResultsForSearch: -1,
    });
  }

  // Select Employee Count
  let employCountSelect = $(document).find('.js-employ-count-select');
  if (employCountSelect.length) {
    employCountSelect.select2({
      placeholder: 'Select Number',
      minimumResultsForSearch: -1,
    });
  }
});
